module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var vehicle = Util.clone(value);

if (vehicle.type == Glonass.VehicleType.Unknown) {
	delete vehicle.type;
}

Util.String.titleIf(vehicle, {
	type: Glonass.VehicleType
});

Util.String.titlesIf(vehicle, {
	insurances: Glonass.VehicleInsurance
});

card.encode(vehicle, {
	type: "тип ",
	model: "модель ",
	color: "цвет ",
	num: "номер ",
	insurances: "страховка ",
	comment: "комментарий "
}, mode);

    ; __append("\n")
    ; __append(escapeFn( Util.String.join([vehicle.type, vehicle.model, vehicle.color, vehicle.num, vehicle.insurances, vehicle.comment], ", ") ))
    ; __append("\n")
  }
  return __output.join("");

}